import React from 'react';

import SvgSearchIcon from '@components/Images/SearchIcon';
import useEventTracking from '@hooks/useEventTracking';
import { search_page_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { ARTICLE_SEARCH } from './constants';

const DeepResearchArticleSearch = () => {
  const { trackEvent } = useEventTracking();

  const handleClickTracking = () => {
    trackEvent(click({ clickTarget: ClickTarget.AnchorLink, clickText: ARTICLE_SEARCH }));
  };

  return (
    <p className="mb-90 mt-72 flex w-full flex-col flex-nowrap items-center justify-center gap-10 px-40 py-0 font-suisse-neue text-body-md font-normal text-grayscale-charcoal xs:flex-row xs:px-0 sm:my-[140px] sm:mt-90">
      <span>
        Looking for an article? Try using{' '}
        <a
          className="underline transition-colors hover:text-primary-magenta dark:hover:text-primary-pink"
          href={search_page_path()}
          onClickCapture={handleClickTracking}
        >
          {ARTICLE_SEARCH}
        </a>
        .
      </span>{' '}
      <SvgSearchIcon className="h-20 w-20 flex-shrink-0 text-primary-magenta" />
    </p>
  );
};

export default DeepResearchArticleSearch;
